import { Button, Stack, SxProps, TextField, Theme } from '@mui/material'

const REASON_MAX_LENGTH = 500

type RejectReasonFormProps = {
  reason: string
  onReasonChange: (reason: string) => void
  onConfirm: () => void
  disabled: boolean
  sx?: SxProps<Theme>
}

export default function RejectReasonForm({
  reason,
  onReasonChange,
  onConfirm,
  disabled,
  sx,
}: RejectReasonFormProps) {
  return (
    <Stack spacing={1} sx={sx}>
      <TextField
        autoFocus
        multiline
        variant="outlined"
        minRows={1}
        maxRows={4}
        placeholder="Add a reason (optional)…"
        value={reason}
        onChange={(event) => onReasonChange(event.target.value)}
        disabled={disabled}
        slotProps={{
          htmlInput: {
            maxLength: REASON_MAX_LENGTH,
            // No visible label, so name it here rather than leaving screen
            // readers on the placeholder.
            'aria-label': 'Rejection reason',
          },
        }}
      />
      <Stack direction="row" justifyContent="flex-end">
        <Button
          color="error"
          variant="contained"
          disabled={disabled}
          onClick={onConfirm}
        >
          Confirm reject
        </Button>
      </Stack>
    </Stack>
  )
}
